
import { useGetAllProjectsQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  location: string;
  fullAddress: string;
  clientName: string;
  estimatedStartDate: DateTime;
  status: string;
}

export function useQuery() {
  const tuple = useGetAllProjectsQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.projects?.map((node) => ({
        id: node.id,
        location: node.locationAddress.formattedFullAddress,
        fullAddress: node.locationAddress.formattedFullAddress,
        clientName: node.name,
        estimatedStartDate: node.startDate ? node.startDate : node.estimatedStartDate,
        status: 'Active'
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
